import { createAction, props } from '@ngrx/store';
import { PaymentDTO } from '@iota/inh-core-v1-management-client';

export const B2CEmployeeActionTypes = {
    LoadB2CPayments: '[B2C Employee] Load Payments',
    LoadB2CPaymentsSuccess: '[B2C Employee] Load Payments Success',
    LoadB2CPaymentsFailure: '[B2C Employee] Load Payments Failure'
};

export const LoadB2CPayments = createAction(B2CEmployeeActionTypes.LoadB2CPayments, props<{ employeeId: string }>());
export const LoadB2CPaymentsSuccess = createAction(B2CEmployeeActionTypes.LoadB2CPaymentsSuccess, props<{ payments: PaymentDTO[] }>());
export const LoadB2CPaymentsFailure = createAction(B2CEmployeeActionTypes.LoadB2CPaymentsFailure, props<{ error: any }>());
